import i18next from 'i18next';

import createSelector from 'web-app/util/custom-create-selector';

export const getMealRegistrations = state => state.entities.meals.foodConsumption.mealRegistrations;

export const getMealRegistration = createSelector(
    getMealRegistrations,
    (state, mealRegistrationId) => mealRegistrationId,
    (mealRegistrations, mealRegistrationId) => mealRegistrations.get(mealRegistrationId),
);

export const mealRegistrationAmountTexts = {
    0: i18next.t('meals.mealRegistration.amount.none'),
    1: i18next.t('meals.mealRegistration.amount.little'),
    2: i18next.t('meals.mealRegistration.amount.half'),
    3: i18next.t('meals.mealRegistration.amount.most'),
    4: i18next.t('meals.mealRegistration.amount.all'),
    5: i18next.t('meals.mealRegistration.amount.all+'),
};

// The slider component from MUI expects an array of objects with the shape {value: number, label: string}
export const mealRegistrationAmountSliderMarks = Object.entries(mealRegistrationAmountTexts).map(([key, value]) => ({
    value: key,
    label: value,
}));
